var map = {
	"./de-CH/config.json": 22440,
	"./de/config.json": 86832,
	"./en/config.json": 20584,
	"./es/config.json": 40240,
	"./fr-CA/config.json": 42068,
	"./fr-CH/config.json": 54152,
	"./fr/config.json": 1400,
	"./it-CH/config.json": 51000,
	"./it/config.json": 54094,
	"./ro/config.json": 62164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99460;